import React, { FC, useMemo } from 'react';

import { FeedbackForm } from '~/src/features/videocontrol/pageBlocks/Cart/FeedbackForm';
import { RequestPoint } from '~/src/features/videocontrol/pageBlocks/Cart/RequestPoint';
import { TotalPoint } from '~/src/features/videocontrol/pageBlocks/Cart/TotalPoint';
import { IProps } from '~/src/features/videocontrol/pageBlocks/Cart/types';
import { useRequisitionContext } from '~/src/features/videocontrol/Provider/useRequisitionContext';

import * as ST from './styled';

export const Cart: FC<IProps> = ({ isAuth, agreement }) => {
    const {
        installLocation,
        plan,
        cameras,
        planOption,
        injector,
        resetCamerasDispatch,
        removeCameraDispatch,
        setPlanDispatch,
        setOptionDispatch,
    } = useRequisitionContext();
    const camerasArray = useMemo(() => Object.values(cameras), [cameras]);

    return (
        <ST.CartContainer>
            {(installLocation || plan) &&
                <ST.Title data-test={'title'}>
                    Проверьте вашу заявку
                </ST.Title>
            }
            <ST.ContentContainer>
                {(installLocation || plan) &&
                    <ST.TitleWrap data-test={'title-wrap'}>
                        <ST.ShopListContainer>
                            <ST.ShopListContent>
                                <ST.TitleList>
                                    Ваша заявка
                                </ST.TitleList>
                                <ST.ShopList>
                                    <RequestPoint
                                        installLocation={installLocation}
                                        title={'Место установки'}
                                        onDeleteHandler={resetCamerasDispatch}
                                    />
                                    {camerasArray.map((camera) => (
                                        <RequestPoint
                                            key={camera.id}
                                            camera={camera}
                                            title={'Камера'}
                                            withCounter={true}
                                            onDeleteHandler={() => removeCameraDispatch(camera.id)}
                                        />
                                    ))}
                                    {!!injector?.count && <RequestPoint
                                        injector={injector}
                                        title={'Инжектор для камеры'}
                                        withCounter={true}
                                    />}
                                    <RequestPoint
                                        plan={plan}
                                        title={'Тариф'}
                                        onDeleteHandler={() => setPlanDispatch(null)}
                                    />
                                    <RequestPoint
                                        planOption={planOption}
                                        title={'Дополнительно к тарифу'}
                                        onDeleteHandler={() => setOptionDispatch(null)}
                                    />
                                    <TotalPoint/>
                                </ST.ShopList>
                            </ST.ShopListContent>
                        </ST.ShopListContainer>
                    </ST.TitleWrap>}
                <FeedbackForm
                    isAuth={isAuth}
                    agreement={agreement}
                />
            </ST.ContentContainer>
        </ST.CartContainer>
    );
};
